module.exports = __webpack_public_path__ + "static/media/btn-social-email.6d29662c.png";